import { z } from 'zod'

/**
 * ⚠️ `coerce` : TanStack Router décode l'URL par `JSON.parse`, et `?q=27` arrive en nombre — un
 * `z.string()` échouerait, et le `.catch` viderait la recherche en silence.
 */
export const urlText = (fallback: string) => z.coerce.string().default(fallback).catch(fallback)

/** Borné par le bas ; le serveur applique de toute façon les siennes (`page-query.ts`). */
export const urlCount = (fallback: number) =>
  z.coerce
    .number()
    .int()
    .default(fallback)
    .catch(fallback)
    .transform((value) => Math.max(value, 0))
